module.exports = __webpack_public_path__ + "media/print/flashcard-styles_image-only-1679987c.png";